export default "__VITE_ASSET__DArMb0nj__"